<script>
export let backend;
let offers = [];
let euPriceGold = 0;
let usPriceGold = 0;
let euPriceUsd = 0;
let usPriceUsd = 0;
let euWotlkPriceGold = 0;
let usWotlkPriceGold = 0;
let euWotlkPriceUsd = 0;
let usWotlkPriceUsd = 0;

function csv() {
  let csvContent = "data:text/csv;charset=utf-8,Descriptor, Provider, Price\n" + offers
    .map(o => o.descriptor + ',' + o.provider + ',' + o.price)
    .join("\n");
  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "avg-wow-offers.csv");
  document.body.appendChild(link); // Required for FF
  link.click();
}

backend.getAvgOffersPerDescriptorWow().then(wowAvgOffers => {
  offers = wowAvgOffers.offers;
  euPriceGold = wowAvgOffers.euPriceGold;
  usPriceGold = wowAvgOffers.usPriceGold;
  euPriceUsd = wowAvgOffers.euPriceUsd;
  usPriceUsd = wowAvgOffers.usPriceUsd;
  euWotlkPriceGold = wowAvgOffers.euWotlkPriceGold;
  usWotlkPriceGold = wowAvgOffers.usWotlkPriceGold;
  euWotlkPriceUsd = wowAvgOffers.euWotlkPriceUsd;
  usWotlkPriceUsd = wowAvgOffers.usWotlkPriceUsd;
});
</script>
<main>
<div class="container">
  <div class="row">
    <div class="col-sm">
      <button type="submit" class="btn btn-light mb-3" on:click|preventDefault={csv}>CSV</button>
    </div>
    <div class="col-sm">
      <div class="card text-white bg-secondary" style="width: 18rem;">
        <div class="card-body">
          <h5 class="card-title">Eu token price: {euPriceGold}</h5>
          <h6 class="card-subtitle mb-2">${euPriceUsd}/1k</h6>
        </div>
      </div>
    </div>
    <div class="col-sm">
      <div class="card text-white bg-secondary" style="width: 18rem;">
        <div class="card-body">
          <h5 class="card-title">Us token price: {usPriceGold}</h5>
          <h6 class="card-subtitle mb-2">${usPriceUsd}/1k</h6>
        </div>
      </div>
    </div>
    <div class="col-sm">
      <div class="card text-white bg-secondary" style="width: 18rem;">
        <div class="card-body">
          <h5 class="card-title">Eu wotlk token price: {euWotlkPriceGold}</h5>
          <h6 class="card-subtitle mb-2">${euWotlkPriceUsd}/1k</h6>
        </div>
      </div>
    </div>
    <div class="col-sm">
      <div class="card text-white bg-secondary" style="width: 18rem;">
        <div class="card-body">
          <h5 class="card-title">Us wotlk token price: {usWotlkPriceGold}</h5>
          <h6 class="card-subtitle mb-2">${usWotlkPriceUsd}/1k</h6>
        </div>
      </div>
    </div>
  </div>
</div>
<table class="table table-sm table-dark table-striped">
  <thead>
  <tr>
    <th scope="col">#</th>
    <th scope="col">Descriptor</th>
    <th scope="col">Provider</th>
    <th scope="col">Price</th>
    <th scope="col">Overgear Price</th>
    <th scope="col">Count</th>
  </tr>
  </thead>
  <tbody>
  {#each offers as offer, index}
  <tr>
    <th scope="row">{index}</th>
    <td>{offer.descriptor}</td>
    <td>{offer.provider}</td>
    <td>{offer.price}</td>
    <td class:table-success="{offer.ogsPrice != null && offer.price < offer.ogsPrice}"
        class:table-warning="{offer.ogsPrice != null && offer.price >= offer.ogsPrice}" 
    >
      {#if offer.ogsPrice != null}
      <div>
        <p class="d-inline">{offer.ogsPrice}</p>
        {#if offer.price < offer.ogsPrice}
        <p class="d-inline"> -{(100 - offer.price * 100 / offer.ogsPrice).toFixed(2)}%</p>
        {/if}
        {#if offer.price >= offer.ogsPrice}
        <p class="d-inline"> +{Math.abs(100 - offer.price * 100 / offer.ogsPrice).toFixed(2)}%</p>
        {/if}
      </div>
      {/if}
    </td>
    <td>{offer.count}</td>
  </tr>
  {/each}
  </tbody>
</table>
</main>

